import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import TagEditForm from './tag_form';
import { Message } from '../Message';
import { TagsService } from '../../services';

@connect(state => {
  return {
    me: state.user.me
  }
})
class TagAdd extends React.Component {

  constructor(props) {
    super(props);

    const tag = {
      name: '',
      enterprise: this.props.me.enterprise
    };

    this.state = {
      added: null,
      tag: tag,
      enterprise: this.props.me.enterprise,
      errorMessage: null,
      localErrorMessage: null
    };
  }

  handleSubmit({name, tagType}) {
    let tag = {
      name: name,
      enterprise: this.state.enterprise,
      tagType: { id: tagType.value }
    };

    TagsService.add(tag).then(tag => {
      this.setState({ added: tag });
    }).catch(error => {
      console.error(error);
      this.setState({ localErrorMessage: error.message });
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    } else {
      return null;
    }
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/tags',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.added) {
      return (
          <Redirect to={{
            pathname: '/admin/tags',
            state: {
              from: this.props.location,
              successMessage: i18next.t('messages.tag-added')
            }
          }}/>
      );
    } else {
      if (this.state.tag && this.state.enterprise) {
        const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
        return (
            <div>
              <div className="row">
                <PageTitle title={i18next.t('pages.tags.add-tag')}
                           backLinkWithParams={{
                             link: {
                               pathname: "/admin/tags",
                               search: backLinkSearch
                             }
                           }} />
              </div>

              {this.renderMessages()}

              <TagEditForm
                  tag={this.state.tag}
                  onSubmit={this.handleSubmit.bind(this)}
                  errorMessage={this.props.errorMessage}
                  backLinkWithParams={{
                    link: {
                      pathname: "/admin/tags",
                      search: backLinkSearch
                    }
                  }}
              />
            </div>
        );
      } else {
        return (
            <div className="loader">{i18next.t('loading')}</div>
        );
      }
    }
  }

}

export default TagAdd;
